exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.html2canvas-container[data-v-06235b8e] {\n  width: 3000px !important;\n  height: 3000px !important;\n}\n", ""]);
